import React, { useState, useContext } from "react";
import { Text, Space } from "react_reusable_components";
import Style from "./QuickLinks.module.scss";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { QUICK_LINKS } from "../../constants";
import variables from "../../themes/base/styles/variables";
import { AuthContext } from "../../globalContext/auth/authProvider";

const QuickLinksStyle = {
  linkHeading: {
    display: variables.dBlock,
    fontSize: variables.fontSizeNormal,
    fontFamily: variables.fontWeightNormal,
    color: variables.textDefault,
  },
  linkDescription: {
    display: variables.dBlock,
    fontSize: variables.fontSizeSmallest,
    fontFamily: variables.fontWeightNormal,
  },
  linksContainer: {
    display: variables.dFlex,
    gap: variables.gapSmaller,
    alignItems: variables.alignCenter,
    padding: variables.paddingSmallest,
    marginBottom: variables.gapXS,
  },
  wrapper: { width: variables.fullWidth },
};

export default function QuickLinks({ hide }) {
  const navigate = useNavigate();
  const intl = useIntl();
  const [authState] = useContext(AuthContext);

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const navigateTo = (route) => {
    navigate(route);
  };

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  const { id: roleId = "" } = authState?.currentRole || {};

  return (
    <Space size={0} direction="vertical" style={QuickLinksStyle.wrapper}>
      {QUICK_LINKS(intl)
        .filter(({ allowedAccess }) => allowedAccess.includes(roleId))
        .map(({ title, icon, filledIcon, description, route }, index) => (
          <div
            onClick={() => {
              navigateTo(route);
              hide();
            }}
            key={title}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
            className={`${Style["links-container"]}`}
            style={QuickLinksStyle.linksContainer}
          >
            {hoveredIndex === index ? (
              <img src={filledIcon} alt="filled-icon" />
            ) : (
              <img src={icon} alt={"icon"} />
            )}
            <div>
              <Text style={QuickLinksStyle.linkHeading}>{title}</Text>
              <Text style={QuickLinksStyle.linkDescription}>{description}</Text>
            </div>
          </div>
        ))}
    </Space>
  );
}
